import e from "../managers/braze-instance.js";
import yt from "./utils/push-utils.js";
export function isPushPermissionGranted() {
  if (e.X()) return yt.isPushPermissionGranted();
}
